import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import React from "react";
import styles from "./ExportButton.module.sass";
import Connect from "colbi_web_ui/lib/components/Connect";
import Spinner from "colbi_web_ui/lib/components/Spinner/Spinner";
import { SovosIcon } from "mosaic-react";
import { DownloadForOffline } from "mosaic-react-icons";

const ExportButton = (props) => {
    const {
        data,
        exportableArray,
        alternativeQueryData,
        modalToUse = "MultipleDownloadDialog",
    } = props;

    const { download, downloadableQueries, locale, i18n, totalLinesCsv, pushDialog, downloadFile, params } =
        useGlobalValue();
    return (
        <Connect to={["search", "downloading"]}>
            {({ downloading }) => (
                <div>
                    {downloadableQueries && downloadableQueries.length > 1 && downloading ? (
                        <div className={styles["backdrop"]}>
                            <div className={`${styles["loader"]}`} />
                        </div>
                    ) : null}
                    <div>
                        {data && data.length ? (
                            <div className={`${styles["export-button"] || ""}`}>
                                {!(exportableArray && exportableArray.length) &&
                                (alternativeQueryData ||
                                    (downloadableQueries && downloadableQueries.length === 1)) ? (
                                    <button
                                        key="download"
                                        className={`${styles["action-button"]} ${
                                            downloading ? styles["has-activity"] : ""
                                        }`}
                                        onClick={() => {
                                            download &&
                                                download(
                                                    alternativeQueryData || downloadableQueries,
                                                    locale,
                                                );
                                        }}
                                    >
                                        <SovosIcon>
                                            <DownloadForOffline style={{ fill: "#015FFF" }} />
                                        </SovosIcon>
                                        {downloading && <Spinner className={styles["spinner"]} />}
                                    </button>
                                ) : (
                                    <button
                                        key="download"
                                        className={`${styles["action-button"]} ${
                                            downloading ? styles["has-activity"] : ""
                                        }`}
                                        onClick={() => {
                                            !downloading &&
                                                pushDialog(
                                                    modalToUse,
                                                    i18n`Please choose one of the following options`,
                                                    {
                                                        queries:
                                                            exportableArray &&
                                                            exportableArray.length
                                                                ? exportableArray.map((elem) => ({
                                                                      ...(alternativeQueryData
                                                                          ? alternativeQueryData
                                                                          : downloadableQueries.length
                                                                            ? downloadableQueries[0]
                                                                            : {}),
                                                                      exportableEntity: elem,
                                                                  }))
                                                                : downloadableQueries,
                                                        download,
                                                        locale,
                                                        totalLinesCsv,
                                                        downloadFile,
                                                        pushDialog,
                                                        params
                                                    },
                                                )
                                                    .then(() => {})
                                                    .catch(() => null);
                                        }}
                                    >
                                        <SovosIcon>
                                            <DownloadForOffline style={{ fill: "#015FFF" }} />
                                        </SovosIcon>
                                        {downloading && <Spinner className={styles["spinner"]} />}
                                    </button>
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </Connect>
    );
};

export default ExportButton;
